export const userConverter = {
  fromFirestore: (snapshot, options) => {
    const user = snapshot.data(options);
    const id = snapshot.id;

    return {
      _id: id,
      ...user,
      cashback: user.cashback || 0,
      createdAt: user.createdAt,
      name: `${user.firstName} ${user.lastName}`,
      phoneNumber: user.phoneNumber,
      phoneCode: user.phoneCode,
      birthDate: user.birthDate,
    };
  },
  toFirestore: (user) => {
    delete user._id;
    return {
      ...user,
    };
  },
};
